import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import React from 'react';
import Link from '../../Link';
import SmartImage from '../../SmartImage';
import { BlogListSliceType } from '../Capabilities/BlogListSlice';

export default function BlogListSlice(props: BlogListSliceType) {
  const { slice } = props;

  return (
    <Box borderBottom={'1px solid'} borderBottomColor='aliceblue.200' pb='40px'>
      <Heading size='h3' as='h3' mb={6}>
        {slice.primary.title}
      </Heading>
      <Flex flexWrap='wrap' gap={5}>
        {slice.items.map((blog, index) => (
          <Link to={blog.button_link} key={index} cursor='pointer'>
            <Box
              maxW='448px'
              bg='rgba(255, 255, 255, 0.5)'
              border='1px solid rgba(0, 0, 0, 0.1)'
              borderRadius='4px'
              borderTop='none'
              alignItems='flex-start'
              overflowX='clip'
            >
              <SmartImage
                h='224px'
                alt='blog'
                src={blog.blog_image.url}
                objectFit='cover'
              />
              <Box p={5} pb={2}>
                <Heading size='h4' as='h4'>
                  {blog.title}
                </Heading>
                <Button variant='linkButton' pl={0} mt={2}>
                  {blog.button_label} <ChevronRightIcon />
                </Button>
              </Box>
            </Box>
          </Link>
        ))}
      </Flex>
    </Box>
  );
}
